// remove duplicates

export const removeDuplicates = (inputArray?: any[]) => {
  if (!inputArray) return inputArray;
  const arrayMap = {};
  inputArray.forEach((elem) => (arrayMap[elem] = 1));
  return Object.keys(arrayMap);
};

export const getLink = (executionId, timestamp) => {
  const params = {
    orgId: '1',
    left: `["${new Date(timestamp).getTime() - 30 * 60 * 1000}","${
      new Date(timestamp).getTime() + 60 * 60 * 1000
    }","Loki",{"expr":"${`{compose_project=\\"retention-${process.env.REACT_APP_TYPE}\\"} |= \\"${executionId}\\""`}}]`,
  };
  const searchParams = new URLSearchParams(params);

  return `https://grafana.beekin.co/explore?${searchParams.toString()}`;
};

export const timestampColumns = [
  'createdAt',
  'updatedAt',
  'CreatedOn',
  'UpdatedOn',
  'UpdateOn',
  'NextInvocation',
  'PasswordUpdatedOn',
  'nextInvocationTime',
];

export const getLocalTime = (timestamp) => {
  if (timestamp === undefined || timestamp === null) return '';
  return new Date(timestamp).toLocaleString('en-US');
};
